import React, { useState } from 'react';
import { MapPinIcon } from 'lucide-react';
import { agenda, agendaFilters } from '../../data/agenda';
import type { AgendaEntry } from '../../types/content';
const typeStyles: Record<AgendaEntry['type'], string> = {
  Compétition: 'bg-flag/10 text-flag',
  Stage: 'bg-azure/10 text-azure',
  Événement: 'bg-ink/10 text-ink/70'
};
export function AgendaSection() {
  const [filter, setFilter] = useState<(typeof agendaFilters)[number]>('Tout');
  const entries = filter === 'Tout' ? agenda : agenda.filter(entry => entry.type === filter);
  return <section id="agenda" className="bg-white py-20 lg:py-24" data-id="element-128" data-mp="2ye9rgmwg0zt0">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-129" data-mp="3c67ldqhl2p4l">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-130" data-mp="3865tua5kbc31">
          <div data-id="element-131" data-mp="3889sodoltkwg">
            <h2 className="ffp-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-132" data-mp="3m5opi3h6suyg">Agenda fédéral</h2>
            <p className="mt-3 text-[16px] text-ink/65" data-id="element-133" data-mp="3h6u7v4uyhcfx">Compétitions, stages et rassemblements des prochaines semaines.</p>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-134" data-mp="2ruooz1lfovys">
            {agendaFilters.map(item => <button key={item} type="button" onClick={() => setFilter(item)} aria-pressed={filter === item} className={`ffp-focus rounded-full border px-4 py-1.5 text-[13px] font-semibold transition-colors duration-150 ease-soft ${filter === item ? 'border-navy bg-navy text-white' : 'border-line text-ink/60 hover:border-navy/40 hover:text-ink'}`} data-id="element-135" data-mp="2wtj9c7z1usl0">
                {item}
              </button>)}
          </div>
        </div>

        <ul className="mt-10 border-t border-line" data-id="element-136" data-mp="3pgm36mss6f4x">
          {entries.map(entry => <li key={entry.id} className="flex items-center gap-5 border-b border-line py-5 sm:gap-8" data-id="element-137" data-mp="3tk1vj6xthtbt">
              <div className="w-14 shrink-0 text-center" data-id="element-138" data-mp="2d7gu6a6wqc9">
                <span className="ffp-display block text-2xl font-extrabold leading-none text-navy" data-id="element-139" data-mp="1yfav9bwq4a1x">{entry.day}</span>
                <span className="mt-1 block text-[12px] font-medium text-ink/50" data-id="element-140" data-mp="1ues4zmahbc1u">{entry.month}</span>
              </div>
              <div className="flex-1" data-id="element-141" data-mp="2865hwhdvtbnw">
                <span className={`inline-block rounded px-2 py-0.5 text-[11px] font-bold uppercase tracking-wider ${typeStyles[entry.type]}`} data-id="element-142" data-mp="287880n3dra2r">
                  {entry.type}
                </span>
                <h3 className="ffp-display mt-1.5 text-[17px] font-bold text-ink lg:text-[19px]" data-id="element-143" data-mp="2d59ttfs6xnhx">{entry.title}</h3>
                <p className="mt-1 flex items-center gap-1.5 text-[13px] text-ink/55" data-id="element-144" data-mp="2r36ou7qzxluh">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-145" data-mp="2m4wwe4wnozck" />
                  {entry.place}
                </p>
              </div>
              <a href="#espaces" className="ffp-focus hidden rounded-full border border-line px-4 py-2 text-[13px] font-semibold text-navy transition-colors duration-150 ease-soft hover:border-navy sm:inline-flex" data-id="element-146" data-mp="wsb82i5nr0gm">
                S’inscrire
              </a>
            </li>)}
          {entries.length === 0 && <li className="border-b border-line py-10 text-center text-[15px] text-ink/55" data-id="element-147" data-mp="2uldx1em0yyex">
              Aucune date de ce type pour l’instant.
            </li>}
        </ul>
      </div>
    </section>;
}